import { classNames } from '@panwds/tailwindcss';
import React, { useMemo } from 'react';
import { useStepItemContext } from './StepItemContext.js';
import { useStepperContext } from './StepperContext.js';
export function StepConnector(props) {
    const stepperContextProps = useStepperContext();
    const stepItemContextProps = useStepItemContext();
    const { direction } = stepperContextProps || props;
    const { index, status, active, complete, inactive, error, disabled } = stepItemContextProps || props;
    const isVertical = direction === 'vertical';
    const disabledClass = disabled ? 'tw-opacity-40' : '';
    const lineStyle = useMemo(() => {
        const showDashedLine = inactive || active;
        const lineColor = error
            ? 'tw-border-red-500'
            : complete
                ? 'tw-border-teal-500'
                : 'tw-border-gray-300 dark:tw-border-gray-900';
        const borderType = showDashedLine ? 'tw-border-dashed' : 'tw-border-solid';
        const defaultClasses = ['tw-flex-auto', 'tw-m-auto', borderType, lineColor, 'tw-border-0'];
        return classNames(isVertical ? 'tw-w-0 tw-border-l' : 'tw-h-0 tw-border-b-2', ...defaultClasses, disabledClass);
    }, [status, direction, active, complete, error, inactive]);
    return React.createElement("div", { "data-testid": `step-connector-${index}`, className: classNames(lineStyle) });
}
//# sourceMappingURL=StepConnector.js.map